import SubModalForm from 'components/shared/Modal/components/SubModal/components/SubModalForm';

import { useTagCreateForm } from '../lib/useTagCreateForm';

import TagCreateFields from './TagCreateFields';

// Sub-modal presentation of the tag-create form. Props are read through a ref so the
// success callbacks always see the host component's latest handlers.
const TagCreateSheet = ({ propsRef }) => {
  const {
    formik,
    selectedColor,
    isLoading,
    handleChange,
    handleSelectColor,
    handleCreate,
    isBlocked,
    blockReason,
    isPrivateBlocked,
    privateBlockReason
  } = useTagCreateForm({
    kind: propsRef.current.kind,
    name: propsRef.current.name,
    addNewTagFromCreated: (tag) => propsRef.current.addNewTagFromCreated?.(tag),
    handleClose: () => propsRef.current.handleClose?.()
  });

  return (
    <SubModalForm
      onClose={() => propsRef.current.handleClose?.()}
      submitText="Create"
      onSubmit={handleCreate}
      isDisabled={isBlocked}
      submitTooltip={blockReason}
      isLoading={isLoading}>
      <div className="flex flex-col gap-4">
        <TagCreateFields
          formik={formik}
          selectedColor={selectedColor}
          onChange={handleChange}
          onSelectColor={handleSelectColor}
          isPrivateBlocked={isPrivateBlocked}
          privateBlockReason={privateBlockReason}
        />
      </div>
    </SubModalForm>
  );
};

export default TagCreateSheet;
